import { render } from "./FestCardPackage.vue?vue&type=template&id=b3ac4462"
import script from "./FestCardPackage.vue?vue&type=script&lang=js"
export * from "./FestCardPackage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__